export const ONE_ON_ONE_TEMPLATE_TYPE = {
  POST_SUMMARY: 'post_meeting',
  PRE_SUMMARY: 'pre_meeting',
}
